import { defineComponent as _defineComponent } from 'vue'
import { isDateSameIgnoringTime } from '@/services/time-utils';
import store from '@/store/store';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainFloatingButton',
  props: { fabType: { type: String, required: true } },
  emits: ['new-walkin', 'new-reservation', 'help'],
  setup(__props, { emit }) {

const props = __props;


const router = useRouter();
const inlineHelpAllowed = process.env.VUE_APP_INLINE_DOCS === 'true';




const fab = ref(false);

const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

const isLoaded = computed(() => store.getters.isLoaded);
const isSameDay = computed(() => isDateSameIgnoringTime(new Date(), store.state.update.date));

const newReservation = (walkin: boolean) => {
  // if newReservation is invoked on other screen than Guests or Tables
  // push the Guests screen to router
  // & if date is different than today, adjust to today.
  if (router.currentRoute.meta?.fab !== 'reservation') {
    if (!isSameDay.value) {
      store.dispatch('changeToDate', new Date());
    }
    router.push('/guests');
  }
  if (walkin) { emit('new-walkin'); } else { emit('new-reservation'); }
};

return { __sfc: true,router, inlineHelpAllowed, props, emit, fab, isTouchDevice, isLoaded, isSameDay, newReservation }
}

})